import { all } from 'redux-saga/effects';
import corpsSagas from './corps';
import authSagas from './auth';
import usersSagas from './users';
import likesSagas from './likes';
import requestsSagas from './requests';
import chatSagas from './chat';
import advertisementSagas from './advertisement';
import eventsSagas from './events';

export default function* rootSaga(): Generator<any> {
  yield all([
    ...corpsSagas,
    ...authSagas,
    ...usersSagas,
    ...likesSagas,
    ...requestsSagas,
    ...chatSagas,
    ...advertisementSagas,
    ...eventsSagas,
  ]);
}
